








































import { Component, Model, Prop, Vue } from 'vue-property-decorator';

import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import Checkbox from '@/components/Checkbox/Checkbox.vue';
import Exclamation from '@/components/icons/Exclamation.vue';

@Component({
  components: {
    Typography,
    Checkbox,
    Exclamation
  }
})
export default class SwitchBox extends Vue {
  @Model('input') modelValue!: boolean;

  @Prop() title!: string;
  @Prop() description?: string;
  @Prop({ default: false }) disabled!: boolean;
  // When true, the master toggle is hidden and the slot content is always shown
  // (used for offer types whose availability rules are mandatory, e.g. Happy Hour).
  @Prop({ default: false }) hideToggle!: boolean;
  // Turns the card into the error state (red border) and, together with
  // `errorMessage`, shows a help-text message below the card.
  @Prop({ default: false }) error!: boolean;
  // Message rendered below the card when `error` is true.
  @Prop() errorMessage?: string;

  onInput(value: boolean) {
    this.$emit('input', value);
  }
}
